

























import {Component, Mixins} from 'vue-property-decorator';
import NumberInput from '@/components/input/NumberInput.vue';
import FilterMixin from '@/components/table/filter/FilterMixin';
import CommonButton from '@/components/button/CommonButton.vue';
import UserApi from '@/api/UserApi';
import {CommonModelUtils, Filter, FilterRetrieveResponse} from '@/model/CommonModel';

@Component({
    components: {NumberInput, CommonButton}
})
export default class NumericRangeFilter extends Mixins<FilterMixin>(FilterMixin) {
    private minNumber: number | undefined = 0;
    private maxNumber: number | undefined = 0;

    private readonly defaultBetweenFilter: Filter = {
        selected: '',
        filterType: 'BETWEEN_NUMERIC',
        valueCode: '',
        valueCode2: '',
        valueLabel: ''
    };
    
    public loadFilter() {
        this.loading = true;
        UserApi.retrieveUserFilters(this.menuId, this.tableHeader.columnId)
               .then((res: FilterRetrieveResponse) => {
                   const filterListElement: Filter
                       = CommonModelUtils.getOrDefault(res.data, {filterList: [this.defaultBetweenFilter]}).filterList[0];
                   this.minNumber = filterListElement.valueCode ? parseInt(filterListElement.valueCode, 10) : undefined;
                   this.maxNumber = filterListElement.valueCode2 ? parseInt(filterListElement.valueCode2, 10) : undefined;
               })
               .finally(() => this.loading = false);
    }

    public onDone() {
        this.getFilterPromise(this.minNumber, this.maxNumber)
            .then((res: any) => {
                this.visible = false;
                this.$emit('refresh');
            });
    }

    protected getFilterPromise(minNumber: any, maxNumber: any) {
        if (isNaN(minNumber) && isNaN(maxNumber)) {
            return UserApi.deleteUserFilters(this.menuId, this.tableHeader.columnId);
        } else {
            return UserApi.updateUserFilters(this.menuId, this.tableHeader.columnId, [{
                filterType: 'BETWEEN_NUMERIC',
                valueCode: minNumber ?? '',
                valueCode2: maxNumber ?? ''
            }]);
        }
    }
}
